import { InitAdapter, SubmitAdapter } from '../../types';

export const initAdapter: InitAdapter = ({ deviation }) =>
  deviation?.extended?.dreamsofart?.promptHidden || false;

export const submitAdapter: SubmitAdapter = ({ promptHidden }) => ({
  dreamsofart_prompt_hidden: !!promptHidden,
});
